module.exports = __webpack_public_path__ + "fonts/Sparkasse_web_Bd.5f90fdbe.woff";